<script setup>
import { getFrontendLocale, setFrontendLocale } from '@/composables/useFrontendLocale'
import UserController from '@controllers/User/UserController'
import { usePage } from '@inertiajs/vue3'
import axios from 'axios'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()

const page = usePage()
const currentLocaleLabel = computed(() => t(locale.value))

const props = defineProps({
  locales: {
    type: Array,
    default: () => ['de', 'en'],
  },
})

function switchLanguage() {
  const currentIndex = props.locales.indexOf(getFrontendLocale())
  const nextIndex = (currentIndex + 1) % props.locales.length
  const selectedLocale = setFrontendLocale(props.locales[nextIndex])

  if (page.props.auth && page.props.auth.user) {
    void axios.put(UserController.update(page.props.auth.user.id).url, {
      language: selectedLocale,
    })
  }
}
</script>

<template>
  <Button severity="secondary" icon="pi pi-globe" :label="currentLocaleLabel" @click="switchLanguage" />
</template>

<i18n>
{
  "de": {
    "de": "Deutsch",
    "en": "Englisch"
  },
  "en": {
    "de": "German",
    "en": "English"
  }
}
</i18n>
